import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import UserAvatar from '~/modules/common/components/Avatars/UserAvatar/UserAvatar';
import { ResourceRoles } from '../entities/role';

const useStyles = makeStyles(theme => ({
  root: { display: 'flex', alignItems: 'center' },
  avatar: {
    flexGrow: 0,
    flexShrink: 0,
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontSize: theme.typography.caption.fontSize
  },
  rows: {
    flexGrow: 1,
    flexShrink: 1,
    padding: theme.spacing(0, 0, 0, 1),
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    overflow: 'hidden'
  },
  row: {
    flexGrow: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...theme.typography.caption,
    lineHeight: `${theme.spacing(2)}px`,
    width: 128
  },
  nameRow: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body2.fontSize
  },
  roleRow: {
    color: theme.palette.text.secondary
  }
}));

const getUserContent = (user, classes) => (
  <div className={classNames(classes.row, classes.nameRow)}>
    {user.displayText}
  </div>
);

export const UserWithRoles = ({
  qeIdTag,
  classes: classesOverride,
  user,
  showTooltip = false
}) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <div
      data-qe-id={qeIdTag ? `UserWithRoles_${qeIdTag}` : undefined}
      className={classes.root}
    >
      <UserAvatar user={user} size="small" className={classes.avatar} />
      <div className={classes.rows}>
        {showTooltip ? (
          <Tooltip title={user.displayText}>
            {getUserContent(user, classes)}
          </Tooltip>
        ) : (
          getUserContent(user, classes)
        )}
        {(user.roles || user.projectRoles) && (
          <div className={classNames(classes.row, classes.roleRow)}>
            <ResourceRoles roles={user.roles || user.projectRoles} />
          </div>
        )}
      </div>
    </div>
  );
};

UserWithRoles.propTypes = {
  qeIdTag: PropTypes.string,
  classes: PropTypes.object,
  user: PropTypes.shape({
    displayText: PropTypes.string.isRequired,
    projectRoles: PropTypes.array,
    roles: PropTypes.array
  }),
  showTooltip: PropTypes.bool
};

export default UserWithRoles;
